import React from 'react';
import { useTranslations } from '@unisporkal/localization';
import {
  Typography,
  TypographyComponentEnum,
  TypographyVariant,
} from '@unisporkal/alliance-ui';

const PerDownload = () => {
  const t = useTranslations();
  return (
    <Typography
      variant={TypographyVariant.body.small}
      component={TypographyComponentEnum.SPAN}
    >
      {t('per_download')}
    </Typography>
  );
};

export default PerDownload;
